<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="flowCircleOne">
      <div class="circle-chart">
        <!-- ,item3 :index ==2 -->
        <div
          class="task-item"
          v-bind:class="{
            item1: index == 0,
            item2: index == 1,
            item3: index == 2,
          }"
          v-for="(item, index) in realtimeData"
          :key="index"
        >
          <div class="task-icon-wrapper">
            {{ item.num }}
            <div class="task-icon"></div>
          </div>
          <div class="task-status">{{ item.name }}</div>
          <!-- <div class="task-count">{{item.ItemValue}}</div> -->
        </div>
      </div>
    </div>
    <!-- 曲线图 -->
    <div class="trend_box">
      <!-- <p class="title">预计高峰 {{maxData.dataTime}} {{maxData.count}}人</p> -->
      <!-- <div class="trend-chart"> -->
      <div class="echartFlow" id="echartZhe"></div>
      <!-- </div> -->
    </div>

    <!-- 人像 -->
    <div class="people_box">
      <div v-for="(item, index) in faceData" class="face_box" :key="item">
        <img
          class="people"
          src="../../../theme-default/src/img/faceUp.png"
          alt=""
        />
        <img class="Face" :src="item.snapUrl" alt="" />
        <div class="time" style="margin-top: 5px">
          {{ item.dataTime | getTime }}
        </div>
        <!-- <div class="time" style="margin-top:5px;">{{item.cameraName}}</div> -->
      </div>
    </div>
    <!-- 车位显示 -->
    <div style="width: 100%">
      <div class="carStatus_display">
        <div class="car_statusOne">
          <img src="../../../theme-default/src/img/car_blue.png" alt="" />
          <p class="name">总车位</p>
          <p class="info colorblue">{{ cheWeiObj.total }}</p>
        </div>
        <div class="car_statusOne">
          <img src="../../../theme-default/src/img/car_red.png" alt="" />
          <p class="name">剩余车位</p>
          <p class="info colorred">{{ cheWeiObj.yu }}</p>
        </div>
        <div class="car_statusOne">
          <img src="../../../theme-default/src/img/car_yellow.png" alt="" />
          <p class="name">今日累计</p>
          <p class="info coloryellow">{{ cheWeiObj.today }}</p>
        </div>
      </div>
      <!-- 车位表格 table-chart-->
      <div class="table_box">
        <el-table
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 96%; margin: 0 auto"
          fixed
        >
          <el-table-column
            prop="name"
            label="停车场"
            width=""
          ></el-table-column>
          <el-table-column
            prop="use_num"
            label="实时车辆"
            width=""
          ></el-table-column>
          <el-table-column prop="" label="负载" width="70">
            <template slot-scope="scope">
              {{ getLv(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="accu_num"
            label="今日累计"
            width="70"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 安检数据 -->
      <div class="anjianBox">
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/anjianrenshu.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">安检人数：</span>
          <span class="lightBlueTxt">{{ anJData.peopleNum }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/baoguo.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">检查包裹：</span>
          <span class="lightBlueTxt">{{ anJData.pack }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/dahuoji.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">收缴打火机：</span>
          <span class="lightBlueTxt">{{ anJData.cigaretteLighter }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/wurenji.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">无人机：</span>
          <span class="lightBlueTxt">{{ anJData.uav }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/weiwenshijian.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">维稳事件：</span>
          <span class="lightBlueTxt">{{
            anJData.stabilityMaintenanceEvent
          }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/weijinpin.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">违禁品：</span>
          <span class="lightBlueTxt">{{ anJData.contrabandGoods }}</span>
        </div>
        <div class="anjianOne">
          <img
            src="../../../theme-default/src/img/a/idcard.png"
            class="icon"
            alt=""
          />
          <span class="blueTxt">未带身份证：</span>
          <span class="lightBlueTxt">{{ anJData.noIdCard }}</span>
        </div>
        <div class="anjianOne">
          <span class="blueTxt" style="margin-left: 0px">更新于：</span>
          <span class="lightBlueTxt">{{ anJData.dataTime | formatDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import {
  facePage,
  realParking,
  getTrendby,
  realCustomer,
  maxCustomer,
  getAnjian,
} from "../../../../../../request/api";
import {
  getAreaYOYMOMData,
  getAreaYOYMOMDataPassenger,
} from "../../../../../../request/analysisApi";
export default {
  name: "HomeViewFlow",
  componentName: "HomeViewFlow",
  data() {
    return {
      realtimeData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      faceData: [],
      cheWeiObj: {
        total: 0,
        yu: 0,
        today: 0,
      },
      trendyData: [],
      trendyDataX: [],
      trendyDataY: [],
      maxData: {},
      anJData: {},
      timer: "",
    };
  },
  filters: {
    getTime(val) {
      let result = val.split(" ");
      let aa = result[1].split(":");
      return aa[0] + ":" + aa[1];
    },
    formatDate(val) {
      // 获取单元格数据
      if (val == null || val == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(val).format("MM-dd hh:mm");
    },
  },
  created() {},
  mounted() {
    console.log("开始");
    this.getRealCustomer();
    //人脸接口
    this.getFaceList();
    this.getrealParingList();
    //趋势
    this.getTrendData();
    this.getAnjianService();
    let that = this;
    this.timer = setInterval(function () {
      that.getRealCustomer();
      //人脸接口
      that.getFaceList();
      that.getrealParingList();
      //趋势
      that.getTrendData();
      that.getAnjianService();
    }, 30000);
  },
  methods: {
    getAnjianService() {
      let _this = this;
      let params = {
        page: 1,
        size: 1,
        order: "data_time",
        sort: "desc",
      };
      getAnjian(params).then((res) => {
        // console.log("安检")
        // console.log(res)
        if (res.code == 0) {
          let data = res.data;
          _this.anJData = data[0];
        }
      });
    },
    getMaxCustomer() {
      let _this = this;
      let params = {};
      maxCustomer(params).then((res) => {
        // console.log("实时在园人数统计")
        // console.log(res)
        if (res.code == 0) {
          let data = res.data;
          _this.maxData = data[0];
        }
      });
    },
    getRealCustomer() {
      let _this = this;
      let params = {
        ticketContentType: "ticket_content_entrance",
        district: global.$config.areaCode,
        districtCode: global.$config.areaCode,
      };
      const promise1 = new Promise((resolve, reject) => {
        getAreaYOYMOMData(params).then((res) => {
          // console.log("实时在园人数统计")
          // console.log(res)
          if (res.code == 0) {
            resolve(res.data);
          }
        });
      });
      var params2 = {
        ticketContentType: "ticket_content_inner",
        district: global.$config.areaCode,
        districtCode: global.$config.areaCode,
      };
      const promise2 = new Promise((resolve, reject) => {
        getAreaYOYMOMData(params2).then((res) => {
          // console.log("实时在园人数统计")
          // console.log(res)
          if (res.code == 0) {
            resolve(res.data);
          }
        });
      });
      var params3 = {
        // "ticketContentType":"ticket_content_inner",
        district: global.$config.areaCode,
        districtCode: global.$config.areaCode,
      };
      const promise3 = new Promise((resolve, reject) => {
        getAreaYOYMOMDataPassenger(params3).then((res) => {
          // console.log("实时在园人数统计")
          // console.log(res)
          if (res.code == 0) {
            resolve(res.data);
          }
        });
      });
      Promise.all([promise1, promise2, promise3]).then((values) => {
        let data1 = values[0];
        let data2 = values[1];
        let data3 = values[2];
        _this.realtimeData = [];
        let obj2 = {
          name: "今日客流",
          num: data3[0].curDayDayCount,
        };
        let obj3 = {
          name: "今日门票",
          num: data1[0].curDayDayCount,
        };
        let obj4 = {
          name: "今日二销",
          num: data2[0].curDayDayCount,
        };
        //  _this.realtimeData.push(obj1);
        _this.realtimeData.push(obj2);
        _this.realtimeData.push(obj3);
        _this.realtimeData.push(obj4);
      });
    },
    getFaceList() {
      let _this = this;
      let params={
        baseUrl:global.$config.api.docking_url,
        data:{
          page: 1,
          size: 4,
          order: "data_time", //按时间字段排序
          sort: "desc", //倒序
       }
      }
      facePage(params).then((res) => {
        // console.log("人脸结果")
        // console.log(res)
        if (res.code == 0) {
          res.data.forEach(item=>{
            if(item.snapUrl.indexOf("http")==-1){
              item.snapUrl = global.$config.api.docking_url+"/preview?file_id="+item.snapUrl
            }
          })
          _this.faceData = res.data;
        }
      });
    },
    getrealParingList() {
      let _this = this;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let day = date.getDate()
      let params = {
          "startTime":year+"-"+month+"-"+day,
          "endTime":year+"-"+month+"-"+day,
          "provinceCode": "",   
          "cityCode": "",       
          "districtCode": global.$config.areaCode,    
          "typeOneCode": ""
      };
      realParking(params).then((res) => {
        if (res.code == 0) {
          let allData = res.data;
           _this.tableData = allData;
              let total = 0;
              let yu = 0;
              let today = 0;
              allData.forEach((item) => {
                if(item.name!=="停车场总入口"&&item.name!=="停车场总出口"){
                   total += item.total_num;
                }
               
                if(item.name=="停车场总入口"){
                   today = item.use_num;
                   yu = item.surplus_num;
                }
                
              });
              _this.cheWeiObj.total = total;
              _this.cheWeiObj.yu = yu;
              _this.cheWeiObj.today = today;
   
          // new MyApis.UniformConfigApi()
          //   .GetConfigItemsListExt({ SysCode: "HomeView", Key: "cp" })
          //   .then((r) => {
          //     let configData = r.data.Data;
          //     for (let i = 0; i < configData.length; i++) {
          //       for (let j = 0; j < allData.length; j++) {
          //         if (configData[i].ItemValue == allData[j].code) {
          //           tempData.push(allData[j]);
          //         }
          //       }
          //     }
          //     _this.tableData = tempData;
          //     let total = 0;
          //     let yu = 0;
          //     let today = 0;
          //     tempData.forEach((item) => {
          //       total += item.totalNum;
          //       yu += item.emptyNum;
          //       today += item.todayNum;
          //     });
          //     _this.cheWeiObj.total = total;
          //     _this.cheWeiObj.yu = yu;
          //     _this.cheWeiObj.today = today;
          //   })
          //   .catch((e) => {
          //     that.$message({
          //       type: "error",
          //       message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          //     });
          //   });
        }
      });
    },
    getLv(scope) {
      if (scope.use_num == "0") {
        return "0%";
      } else {
        let result = scope.use_num / scope.total_num;
        result = result.toFixed(2);
        return (result * 100).toFixed(2) + "%";
      }
    },
    getTrendData() {
      let _this = this;
      let params = {
        timeType: "hour",
        timeValue: 24,
      };
      getTrendby(params).then((res) => {
        let data = res.data;
        data.forEach((item) => {
          let result = item.dataTime.split(" ");
          let str = result[1].split(":");
          item.ItemKey = Number(str[0]);
          item.ItemValue = item.count;
          if (item.ItemKey > 7 && item.ItemKey < 19) {
            _this.trendyDataX.push(item.ItemKey);
            _this.trendyDataY.push(item.count);
          }
        });
        _this.trendyData = data;
        if (data.length > 0) {
          _this.drawChart(data);
        }
      });
    },
    searchRealtimeData() {
      let that = this;
      let searchInfo = {
        SysCode: "HomeView",
        Key: "RealTimeData",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.realtimeData = r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },

    drawChart(data) {
      // eslint-disable-next-line no-undef
      if (
        !drawPassengerFlowTrend ||
        typeof drawPassengerFlowTrend != "function"
      ) {
        console.error("drawPassengerFlowTrend is not a function");
        return;
      }
      // eslint-disable-next-line no-undef
      var echartInstance = echarts.getInstanceByDom($(".echartFlow")[0]);
      if (echartInstance) echartInstance.dispose();
      // eslint-disable-next-line no-undef
      drawPassengerFlowTrend.call($(".echartFlow")[0], data);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
div.flowCircleOne {
  padding-top: 5%;
}
.trend_box {
  width: 100%;
  // height:18%;
  position: relative;
  .title {
    font-size: 14px;
    line-height: 24px;
    color: #2ac1ff;
    text-align: center;
  }
  .echartFlow {
    height: 120px;
  }
}
.people_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  padding: 0px 12px;
  .face_box {
    position: relative;
    width: 7.3rem;
    // height: 6.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .people {
      width: 100%;
      height: 6.7rem;
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 100;
    }
    .Face {
      width: 100%;
      height: 6.7rem;
    }
    .time {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 2.4rem;
      letter-spacing: 0px;
      color: #2ac1ff;
      height: 2.4rem;
      text-align: center;
    }
  }
}
.carStatus_display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
  padding: 0px 12px;
  .car_statusOne {
    width: 7.6rem;
    // height:67px;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .name {
      text-align: center;
      font-size: 1.4rem;
      color: #fff;
      margin-top: 0px;
    }
    .info {
      width: 100%;
      font-size: 18px;
      position: absolute;
      text-align: center;
      bottom: 18px;
      left: 0px;
    }
    .colorblue {
      color: #00bdff;
    }
    .colorred {
      color: #fd4d4e;
    }
    .coloryellow {
      color: #fedb4e;
    }
  }
}
.table_box {
  margin-top: 1.5rem;
}
.anjianBox {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 2rem 2rem;
  .anjianOne {
    width: 50%;
    height: 3.6rem;
    line-height: 3.6rem;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
    .icon {
      width: 2.8rem;
      height: 2.8rem;
    }
    .blueTxt {
      font-size: 1.6rem;
      color: #00c6ff;
      margin-left: 2rem;
    }
    .lightBlueTxt {
      font-size: 1.6rem;
      color: #9fceff;
    }
  }
}
</style>